import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Progress, Alert } from 'reactstrap';

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [showForm, setShowForm] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'clarovideo';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage")

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="claro-video-login-container mt-5" ref={nodeRef}>
        <h3>Inicia sesión</h3>
        <form onSubmit={(event) => onSubmit(event)}>
          <div className="form-group mt-5">
            <label className="claro-video-label">Correo electrónico</label>
            <input
              type="email"
              disabled={onLogin}
              className="form-control input-email-claro"
              aria-label="Large"
              placeholder={translate("PleaceHolderEmail")}
              onChange={(e) => setUsername(e.target.value)}
              required={true}
              tabIndex={1}
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
            />
          </div>
          <div className="form-group mt-5">
            <label className="claro-video-label">Contraseña</label>
            <input
              type="password"
              disabled={onLogin}
              className="form-control input-pass-claro"
              aria-label="Large"
              placeholder={translate("Contraseña")}
              onChange={(e) => setPassword(e.target.value)}
              tabIndex={1}
              required={true}
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
            />
          </div>
          {!onLogin ? (
            <button
              type="submit"
              className="btn btn-claro-video btn-lg btn-block"
              block={!parameters.failureRedirect}
              tabIndex={1}
              name="submit"
              disabled={!props.turnstileSuccess}
            >
              {translate("ingresar")}
            </button>
          ) : (
            <Progress animated color="danger" value={100} />
          )}
          <div className="message-container-clarovideo">
            <Alert
              color="danger"
              id="error-message"
              isOpen={error.open}
              toggle={() => setError({ error: { open: false } })}
            >
              {error.message}
            </Alert>
          </div>
        </form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
